import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundReferenceBuilder from '@/pages/PagePlaygroundReferenceBuilder'

export const Route = createFileRoute('/tools/character-sheet')({
  component: () => <PagePlaygroundReferenceBuilder preset="character-sheet" />,
  validateSearch: (search: Record<string, unknown>): { runId?: string; character?: string } => ({
    runId: typeof search.runId === 'string' ? search.runId : undefined,
    character: typeof search.character === 'string' ? search.character : undefined
  })
})
